import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, FlaskConical } from "lucide-react";
import { BRAND, NAV_LINKS } from "@/lib/brand";
import { telLink, mailLink } from "@/lib/whatsapp";

const PRODUCT_CATS = [
  { label: "Minerals", cat: "minerals" },
  { label: "Probiotics", cat: "probiotics" },
  { label: "Gut Health", cat: "gut-health" },
  { label: "Nutrition", cat: "vitamins" },
  { label: "Growth Support", cat: "growth" },
  { label: "Pond Management", cat: "pond-management" },
  { label: "Water Quality", cat: "water-quality" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" style={{ background: "#063B63", color: "rgba(255,255,255,0.8)" }}>
      <div className="container-x py-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="inline-block bg-white rounded-xl px-3 py-2 mb-4">
              <img src={BRAND.logoWhite} alt="BIOSYN Advanced Aquaculture Solutions" className="h-12" />
            </div>
            <p className="text-sm leading-relaxed" style={{ color: "#16B8D4" }}>{BRAND.tagline}</p>
          </div>

          <div>
            <h4 className="font-heading text-white font-bold mb-4">Navigate</h4>
            <ul className="space-y-2.5 text-sm">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`} className="hover:text-white transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/aqua-lab" data-testid="footer-nav-aqua-lab" className="hover:text-white transition-colors flex items-center gap-1.5">
                  <FlaskConical className="w-3.5 h-3.5" style={{ color: "#16B8D4" }} /> BIOSYN Aqua Lab
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-white font-bold mb-4">Product Categories</h4>
            <ul className="space-y-2.5 text-sm">
              {PRODUCT_CATS.map((c) => (
                <li key={c.cat}>
                  <Link to={`/products?category=${c.cat}`} className="hover:text-white transition-colors">{c.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-white font-bold mb-4">Contact</h4>
            <ul className="space-y-3.5 text-sm">
              <li className="flex gap-3">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" style={{ color: "#16B8D4" }} />
                <span>Auto Nagar, Belagavi,<br />Karnataka – 590015</span>
              </li>
              <li className="flex gap-3">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" style={{ color: "#3FAE35" }} />
                <span>
                  <span className="font-semibold text-white">Corporate Office:</span><br />
                  H.No. 20-79/301, Surya Prabha Nilayam,<br />Dayanand Nagar, Secunderabad,<br />Medchal-Malkajgiri, Telangana – 500044<br />
                  <span className="text-xs">GSTIN: 36B00RPP1044Q1ZA</span>
                </span>
              </li>
              <li className="flex gap-3 items-center">
                <Phone className="w-4 h-4 shrink-0" style={{ color: "#16B8D4" }} />
                <a href={telLink()} data-testid="footer-phone" className="hover:text-white transition-colors">{BRAND.phone}</a>
              </li>
              <li className="flex gap-3 items-center">
                <Mail className="w-4 h-4 shrink-0" style={{ color: "#16B8D4" }} />
                <a href={mailLink("Product Enquiry")} data-testid="footer-email" className="hover:text-white transition-colors break-all">{BRAND.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t flex flex-col md:flex-row gap-4 items-center justify-between text-xs" style={{ borderColor: "rgba(255,255,255,0.12)" }}>
          <p className="font-semibold tracking-wide" style={{ color: "#3FAE35" }}>
            FOR AQUACULTURE USE ONLY • NOT FOR HUMAN USE
          </p>
          <p>© 2026 BIOSYN. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}
